import Vue from 'vue';
import staticConstants from '../constants/appConstants';
import successConstant from '../constants/appSuccess';
import errorConstants from '../constants/appErrors';

let firstArgument = '';
let secondArgument = '';
let thirdArgument = '';
let fourthArgument = '';

const commonMethod = (key, section, options = {}) => {
  firstArgument = (options.firstArgument !== '') ? options.firstArgument : '';
  secondArgument = (options.secondArgument !== '') ? options.secondArgument : '';
  thirdArgument = (options.thirdArgument !== '') ? options.thirdArgument : '';
  fourthArgument = (options.fourthArgument !== '') ? options.fourthArgument : '';
  return section[key]
    .replace('#firstArgument#', firstArgument)
    .replace('#secondArgument#', secondArgument)
    .replace('#thirdArgument#', thirdArgument)
    .replace('#fourthArgument#', fourthArgument);
};

const APP_CONSTANTS = {
  install() {
    Vue.prototype.$getConst = (key, options = {}) => commonMethod(key, staticConstants, options);
    Vue.prototype.$getSuccess = (key, options = {}) => commonMethod(key, successConstant, options);
    Vue.prototype.$getErr = (key, options = {}) => commonMethod(key, errorConstants, options);
  },
};

export default APP_CONSTANTS;
